
import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import CustomTargetingModule from '@/models/CustomTargeting'
import SelectOption from '@/models/interface/SelectOption'
import SelectPicker from '../SelectPicker/SelectPicker.vue'

@Component({
  components: {
    SelectPicker,
  },
})
export default class CustomTargetingSelect extends ViewModel {
  @Ref() public selectRef!: SelectPicker

  @Ref() public wrapper!: HTMLDivElement

  @Prop({ default: () => [] })
  public options!: SelectOption[]

  @Prop({ default: false })
  public dontMixOptions!: boolean

  @Prop({ default: false })
  public multiple!: boolean

  @Prop()
  public value!: any

  @Prop()
  public item!: any

  @Prop()
  public onItemChange!: any

  @Prop({ default: false })
  public watchItem!: boolean

  @Prop({ default: true })
  public edit!: boolean

  @Prop({ default: false })
  public ignoreLoading!: boolean

  public requested_options: SelectOption[] = []

  public busy: boolean = false

  public ready: boolean = false

  public uuid: string = ''

  public reload: boolean = false

  @Watch('item')
  public itemWatch(val: any, oldVal: any) {
    if (this.watchItem && typeof this.onItemChange === 'function') {
      this.onItemChange({
        oldVal,
        item: this.item,
        clearOptions: this.clearOptions,
        searchOptions: this.searchOptions,
        instance: this,
      })
    }
  }

  public get local_value() {
    return this.value
  }

  public set local_value(value: any) {
    // console.log('local_value', { value, reload: this.reload })
    if (!value) return
    this.$emit('input', value)
  }

  public loaded_options: boolean = false

  public get local_options() {
    if (this.item === 'key_value') {
      return this.options
    }

    let opts: any = this.requested_options

    const uniqueOptions = opts.filter((option: SelectOption, index: number) => index === opts.findIndex((o: SelectOption) => o.value === option.value))

    return uniqueOptions
  }

  public created() {
    if (this.edit) {
      if (!this.value || (Array.isArray(this.value) && this.value.length == 0)) {
        this.local_value = this.value
        this.ready = true
      } else {
        this.busy = true
        this.local_value = this.value

        if (this.item !== 'key_value') {
          this.search({ value: this.value })
        }
      }
    } else {
      this.search({ value: this.value })
    }
  }

  public mounted() {
    this.uuid = this.randomUUID()
    // this.loadTagsIfAny()
    this.reload = true
    setTimeout(() => {
      if (this.item === 'key_value') {
        this.ready = true
        this.busy = false
      }

      this.reload = false
      this.$nextTick(() => {
        this.wrapper.classList.remove('smooth-slide-in-right')
      })
    }, 500)
  }

  public async search(args: Record<string, any>, clb: any = null) {
    if (this.ignoreLoading && this.ready) {
      this.busy = false
      this.ready = true
      return
    }

    return CustomTargetingModule.searchOptions({
      ...args,
    }).then(response => {
      this.requested_options = response
      setTimeout(() => {
        this.selectRef.updateLabel()
      }, 200)
      if (clb) {
        clb(response)
      }
      this.busy = false
      this.ready = true
    })
  }

  public searchOptions(search: any = '*', clb: any = null): void {
    if (this.ignoreLoading && this.ready) {
      this.busy = false
      this.ready = true
      return
    }

    this.busy = true
    if (!search) search = '*'

    CustomTargetingModule.searchOptions({
      search: search.includes('*') ? search : `*${search}*`,
    }).then(response => {
      this.requested_options = response
      if (clb) {
        clb(response, this)
      }
      this.busy = false
      this.ready = true
    })
  }

  public open() {
    this.$emit('open', this.uuid)
    if (this.item !== 'key_value') this.searchOptions()
  }

  public clearOptions(clb: any = null) {
    this.ready = false
    this.requested_options = []
    this.ready = true

    if (clb) {
      clb(this)
    }
  }
}
